module.exports = "/_next/static/images/video_id_7184325903856520490-60c06eb7d8263b669d98a68a99333f41.jpg";